import React, { useMemo } from "react";
import { Modal } from "react-bootstrap";
import SLMTitleDetailsList from "containers/slm/shared/SLMTitleDetailsList";
import { createElementIdFactory, createSLMTitleDetailsModalElementIds } from "utils/elementIds";

export default function SLMTitleDetailsModal({
  show,
  onClose,
  user,
  updateTableState,
  filter,
  saveForm,
  data,
  saveRecord,
  deleteRecord,
  isAuthenticated,
  validateRelatedRecord,
  dataFetch,
  streetOptions,
  context,
  ctx,
  stateCode,
}) {
  const createId = useMemo(() => createElementIdFactory("slm-title-details-modal"), []);
  const elementIds = useMemo(() => createSLMTitleDetailsModalElementIds(createId), [createId]);

  return (
    <Modal show={show} onHide={onClose} dialogClassName="slm-title-details-modal-wide" size="xl" id={elementIds.modal}>
      <Modal.Header closeButton>
        <Modal.Title id={elementIds.title}>Parcels</Modal.Title>
      </Modal.Header>
      <Modal.Body className="px-2 px-md-3" style={{ overflowX: "auto" }}>
        <SLMTitleDetailsList
          filter={filter}
          isAuthenticated={isAuthenticated}
          isLoading={false}
          controlType="table"
          saveForm={saveForm}
          user={user}
          data={data}
          dataFetch={dataFetch}
          updateTableState={updateTableState}
          saveRecord={saveRecord}
          deleteRecord={deleteRecord}
          validateRelatedRecord={validateRelatedRecord}
          streetOptions={streetOptions}
          context={context}
          ctx={ctx}
          stateCode={stateCode}
        />
      </Modal.Body>
    </Modal>
  );
}
